import { InstrumentBatchUploadByIdReduxState, InstrumentBatchUploadReducerDispatch, InstrumentBatchUploadReduxState, InstrumentBatchUploadTypes } from "./types";

const INSTRUMNET_BATCH_UPLOAD_LIST_INIT_STATE = {
    loading: true,
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    error: null
};
const InstrumentBatchUploadListReducer=(state : InstrumentBatchUploadReduxState=INSTRUMNET_BATCH_UPLOAD_LIST_INIT_STATE,action:InstrumentBatchUploadReducerDispatch)=>{
    switch (action.type) {
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD: {
            return {
                ...state,
                error: null,
                loading: true
            };
        }
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };
        }
        case InstrumentBatchUploadTypes.RESET:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
}

const InstrumentsListByBatchIdReducer=(state : InstrumentBatchUploadReduxState=INSTRUMNET_BATCH_UPLOAD_LIST_INIT_STATE,action:InstrumentBatchUploadReducerDispatch)=>{
    switch (action.type) {
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID: {
            return {
                ...state,
                error: null,
                loading: true
            };
        }
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };
        }
        case InstrumentBatchUploadTypes.RESET:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
}


const INSTRUMENT_BATCH_UPLOAD_INIT_STATE = {
    loading: false,
    data: {},
    error: null
};
const  InstrumentBatchUploadReducer = (state: InstrumentBatchUploadByIdReduxState = INSTRUMENT_BATCH_UPLOAD_INIT_STATE, action: InstrumentBatchUploadReducerDispatch) => {
    switch (action.type) {
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID: {
            return {
                ...state,
                error: null,
                loading: true
            };
        }
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }
        case InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };
        }
        case InstrumentBatchUploadTypes.RESET:
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
}
export {
    InstrumentBatchUploadListReducer,
    InstrumentBatchUploadReducer,
    InstrumentsListByBatchIdReducer
}